import React, { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { confirmModal, isMobileScreen } from '@apply/ui';
import { useAuthentication } from '../../LoginPage';
//import { useIdleTimer } from 'react-idle-timer';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import {
    Menu,
    MenuItem,
    FlyoutMenuButton,
    FlyoutDirection,
    IconButtonTheme,
    IconButtonSize,
    IconButton,
} from '@apply/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { faSignOut, faBars, faMedal } from '@fortawesome/free-solid-svg-icons';

const reactPlugin = new ReactPlugin();
const mobileScreen = isMobileScreen();

export const appInsightsApply = import.meta.env.VITE_APPINSIGHTS_CLIENT_APPLY;
const ai = new ApplicationInsights({
    config: {
        instrumentationKey: appInsightsApply,
        enableAutoRouteTracking: true,
        extensions: [reactPlugin],
    },
});
ai.loadAppInsights();

export const Header: React.FC<{ printMode? }> = ({ printMode }) => {
    const { authentication, isAuthenticated, logout } = useAuthentication();
    const navigate = useNavigate();

    const [name, setName] = useState<string>('');
    // const [logoutTimeout, setLogoutTimeout] = useState<NodeJS.Timeout>();
    // const [isIdle, setIsIdle] = useState(false);
    // const idleWarningDuration = 1000 * 60 * 2;
    // const sessionDuration = 1000 * 60 * 20;
    // const idleDuration = sessionDuration - idleWarningDuration;

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        } else {
            setName(`${authentication.user.firstName} ${authentication.user.lastName}`);
        }
    }, [authentication, isAuthenticated]);

    const onConfirmLogout = () => {
        const stackTrace = Error().stack;
        ai.appInsights.trackTrace({ message: 'onConfirmLogout' }, { stackTrace });
        logout();
        navigate('/login');
    };

    const handleLogout = () => {
        confirmModal({
            title: 'Confirm Logout',
            message: `Warning: Unsaved work may be lost`,
            onConfirm: onConfirmLogout,
            okLabel: 'Yes',
            cancelLabel: 'No',
        });
    };

    const renderHeaderNav = () => {
        if (!mobileScreen) {
            return (
                <>
                    <IconButton
                        id='notificationsButton'
                        theme={IconButtonTheme.White}
                        size={IconButtonSize.Medium}
                        icon={faBell}
                    ></IconButton>
                    <FlyoutMenuButton
                        id='profileButton'
                        direction={FlyoutDirection.Left}
                        theme={IconButtonTheme.White}
                        size={IconButtonSize.Medium}
                        icon={faUserCircle}
                    >
                        <ul style={{ textAlign: 'center' }}>
                            <li>
                                <a onClick={handleLogout}>
                                    <FontAwesomeIcon
                                        icon={faSignOut}
                                        style={{ paddingRight: '10px' }}
                                    />
                                    Logout
                                </a>
                            </li>
                        </ul>
                    </FlyoutMenuButton>
                </>
            );
        } else {
            return (
                <>
                    <IconButton
                        id='notificationsButton'
                        theme={IconButtonTheme.Transparent}
                        size={IconButtonSize.Small}
                        icon={faBell}
                    ></IconButton>
                    <FlyoutMenuButton
                        id='menuButton'
                        direction={FlyoutDirection.Left}
                        theme={IconButtonTheme.Transparent}
                        size={IconButtonSize.Small}
                        icon={faBars}
                    >
                        <ul style={{ textAlign: 'center' }}>
                            <li>
                                <a href='/experience'>
                                    <FontAwesomeIcon
                                        icon={faMedal}
                                        style={{ paddingRight: '10px' }}
                                    />
                                    Experience
                                </a>
                            </li>
                            <hr className='flyout-itemSeperator' />
                            <li>
                                <a onClick={handleLogout}>
                                    <FontAwesomeIcon
                                        icon={faSignOut}
                                        style={{ paddingRight: '10px' }}
                                    />
                                    Logout
                                </a>
                            </li>
                        </ul>
                    </FlyoutMenuButton>
                </>
            );
        }
    };

    return (
        <>
            <header>
                <div className='headerWrapper'>
                    <div className='logoWrapper'>
                        <a
                            href='/'
                            className='logo no-print'
                        >
                            <img
                                src='/assets/img/logo.webp.html'
                                alt='Builder Finance'
                            />
                        </a>
                    </div>
                    <div className='menuWrapper'>
                        <Menu>
                            <MenuItem
                                active={true}
                                hint='BFI Apply Home Page'
                                url='/home'
                            >
                                Home
                            </MenuItem>
                            {/* <MenuItem
                                url='/businessandpeople'
                                active={true}
                            >
                                Business & People
                            </MenuItem> */}
                            <MenuItem url='/experience'>Experience</MenuItem>
                        </Menu>
                    </div>
                    <div
                        className={`${printMode ? 'hidden' : 'headerNav'}`}
                        style={{
                            visibility: isAuthenticated ? 'visible' : 'hidden',
                        }}
                    >
                        {renderHeaderNav()}
                    </div>
                </div>
            </header>
        </>
    );
};
